import type { IvrFlowType } from './types'
import { GATEWAY_HOST } from '@/root/api/apiConstants'
import {
  getIndMoneyCoreAPI,
  getInsuranceServiceUrl,
  getWidgetServiceUrl,
} from '@/root/api/url-constants'

export const indMoneyApiBaseUrl = getIndMoneyCoreAPI()
export const indMoneyProfileXUrl = 'https://apixt-iw.indmoney.com/profilex/api'
export const indMoneyApiHost = 'https://apixt-iw.indmoney.com/core'
export const insuranceApiBaseUrl = getInsuranceServiceUrl()

/*************************** GET APIs ************************ */
export const getIntroScreenGetApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/equity/us-stock-two-in-one-account-config/?flowType=${flowType}`

export const getStocksAccountConsentScreenGetApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${getWidgetServiceUrl()}/user/get-widget/?version=3.6.8&platform=WEB&isSmsSyncInProgress=0&widgetId=71&flowType=${flowType}`

export const getIvrStepApiUrl = (flowType: IvrFlowType = 'US_STOCKS_SBM') =>
  `${indMoneyApiBaseUrl}/v1/user/ivr-step/?flowType=${flowType}`

export const getUserProfileGetApi = (flowType: IvrFlowType = 'US_STOCKS_SBM') =>
  `${indMoneyProfileXUrl}/v5/userprofile/profile/?flowType=${flowType}`

export const getCheckKycStatusApi = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
  panNum: string,
) =>
  `${indMoneyApiBaseUrl}/v1/user/kyc-status/?flowType=${flowType}&panNum=${panNum}`

export const getAddressConfigApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) => `${indMoneyApiBaseUrl}/v2/user/kyc/address-config/?flowType=${flowType}`

export const getPinCodeAddressApiUrl = (pincode: string) =>
  `${indMoneyApiBaseUrl}/api/v1/common/pincode/${pincode}/`

export const getOTPConfigApiUrl = (flowType: IvrFlowType = 'US_STOCKS_SBM') =>
  `${indMoneyApiBaseUrl}/v1/user/otp-config/?flowType=${flowType}`

export const getDwSbmApiUrl = (flowType: IvrFlowType = 'US_STOCKS_SBM') =>
  `${indMoneyApiBaseUrl}/v1/user/get-dw-sbm-accounts/?flowType=${flowType}`

export const getPollingStatusRequestGetApiUrl = (
  request_id: string,
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/user/kyc/fetch-request-status/${request_id}/?flowType=${flowType}`

export const getPollingFetchAadharApiUrl = (
  request_id: string,
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/user/kyc/fetch-aadhar-ckyc-status/${request_id}/?flowType=${flowType}`

export const getFetchDigioScreenApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) => `${indMoneyApiBaseUrl}/v1/user/digio/screen-config/?flowType=${flowType}`

export const getCommonChoicesApiUrl = () =>
  `${indMoneyApiBaseUrl}/v2/common/choices/`

export const getEmployeeDetailsConfigApiUrl = () =>
  `${indMoneyApiBaseUrl}/v1/equity/dw-user/employment_details/config/`

export const getBrokerTnCConfigApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) => `${indMoneyApiBaseUrl}/v2/user/broker-tnc-config/?flowType=${flowType}`

/** *********************** POST APIs **************************/

export const getStocksAccountContentScreenPostApiUrl = () =>
  `${indMoneyApiBaseUrl}/v1/user/add-consent`

export const get_postUserProfileApi = getUserProfileGetApi

export const postIvrDocsApiUrl = (
  screenName: string = 'SELFIE',
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/user/ivr-docs/?flowType=${flowType}&screenName=${screenName}`

export const postIvrPANApiUrl = (
  screenName: string = 'SELFIE',
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v2/user/ivr-docs/?flowType=${flowType}&screenName=${screenName}`

export const postIvrDocDataApiUrl = (flowType: IvrFlowType = 'US_STOCKS_SBM') =>
  `${indMoneyApiBaseUrl}/v1/user/ivr-doc-data/?flowType=${flowType}`

export const postAddressConsentApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) => `${indMoneyApiBaseUrl}/v1/user/address-confirmation/?flowType=${flowType}`

export const postVerifyIPApiUrl = (flowType: IvrFlowType = 'US_STOCKS_SBM') =>
  `${indMoneyApiBaseUrl}/v1/user/verify_ip/?flowType=${flowType}`

export const postRiskProfileApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) => `${indMoneyApiBaseUrl}/v1/equity/us-stock-account/?flowType=${flowType}`

export const postStatusRequestApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/user/kyc/initiate-status-request/?flowType=${flowType}`

export const postNomineeApiUrl = (flowType: IvrFlowType = 'NOMINEE_ADD') =>
  `${indMoneyApiBaseUrl}/v1/user/kyc/nominee/?flowType=${flowType}`

export const postInitiateAadharApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/user/kyc/initiate-aadhar-ckyc/?flowType=${flowType}`

export const postDigioInitiateRequestApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/user/digio/initiate-request/?flowType=${flowType}`

export const postDigioRejectRequestApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) => `${indMoneyApiBaseUrl}/v1/user/digio/reject-request/?flowType=${flowType}`

export const postVerifyOTPApiUrl = (flowType: IvrFlowType = 'US_STOCKS_SBM') =>
  `${indMoneyApiBaseUrl}/v1/user/save-consent/?flowType=${flowType}`

export const postVerifyEmailApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) => `${indMoneyApiBaseUrl}/v1/user/email/save/?flowType=${flowType}`

export const postVerifyEmailOTPApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/user/email-verification/verify/?flowType=${flowType}`

export const resendVerifyEmailOTPApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) => `${indMoneyApiBaseUrl}/v1/user/email/save/?flowType=${flowType}`

export const resendVerifyEmailVerificationApiUrl = (
  flowType: IvrFlowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/user/send-verification-email/?flowType=${flowType}`

export const leadCreationApi = `${insuranceApiBaseUrl}/v3/term-insurance/catalogue/create/calender`

export const getOtpApi = `${GATEWAY_HOST}/indshield/public/ext/v4/otp/generate`

export const verifyOtpApi = `${GATEWAY_HOST}/indshield/public/ext/v6/otp/verify`
